import { EventType } from '@azure/msal-browser';
import { authService } from '@/services/authService';
export default (onSuccessCallback, onFailureCallback) => {
    const eventsHandlerId = authService.getMSALObj().addEventCallback((message) => {
        switch (message.eventType) {
            case EventType.LOGIN_SUCCESS:
            case EventType.SSO_SILENT_SUCCESS:
            case EventType.ACQUIRE_TOKEN_SUCCESS:
                console.log('LOGIN SUCCESS EVENT');
                onSuccessCallback();
                break;
            case EventType.LOGIN_FAILURE:
            case EventType.SSO_SILENT_FAILURE:
            case EventType.ACQUIRE_TOKEN_FAILURE:
                console.log('LOGIN FAILURE EVENT');
                onFailureCallback();
                break;
            default:
        }
    });
    let removeMSALEventsHandler;
    if (eventsHandlerId) {
        removeMSALEventsHandler = () => authService.getMSALObj().removeEventCallback(eventsHandlerId);
    }
    return removeMSALEventsHandler;
};
